import { GlobalProvider } from './contexts/GlobalProvider';
import { Switchboard } from './routes/Switchboard/Switchboard';
import { PublicMenuEntry } from './pages/DigitalMenuPage/PublicMenuEntry';

export const App = () => window.location.pathname.startsWith('/menu/') ? <PublicMenuEntry /> : (
    <GlobalProvider>
        <Switchboard />
    </GlobalProvider>
);
